import { authenticatedPost } from "../Services/core";

export const SearchList = async (request) => {
   return await authenticatedPost(request, process.env.REACT_APP_BASE_URL+'search/list');
}
